import { render } from "./End.vue?vue&type=template&id=3bd6cc1a"
import script from "./End.vue?vue&type=script&lang=js"
export * from "./End.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aron/Herd/de-veense-veiling/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__